class Animation {
    constructor() {

        function scrollTrigger(selector, options = {}) {
            let els = document.querySelectorAll(selector);
            els = Array.from(els);
            els.forEach(el => {
                addObserver(el, options);
            });
        }
        
        function addObserver(el, options) {
            let observer = new IntersectionObserver((entries, observer) => {
                entries.forEach(entry => {
                    if(entry.isIntersecting) {
                        entry.target.classList.add('active');
                        observer.unobserve(entry.target);
                    }
                })
            }, options);
            observer.observe(el);
        }
        
        scrollTrigger('.graphic', { rootMargin: '-150px' });

        scrollTrigger('.graphL', { rootMargin: '-300px' });

        scrollTrigger('.show-left', { rootMargin: '-300px' });
        
        scrollTrigger('.show-up', { rootMargin: '-50px' });
        
        scrollTrigger('.show-down', { rootMargin: '-200px' });

        console.log('Animation');

    }    
}

export default Animation;